import adminRequest from '../../../config/adminRequest';
import { UsdtUri } from '../../core/configs/services';
import { AdminResponse } from '../models/adminResponse';

export type CRotationSkip = {
  id: string;
  scope: string;
  fromAddress: string;
  toAddress: string;
  remark?: string;
  createdAt: string;
};

export type CRate = {
  fromAddress: string;
  toAddress: string;
  total: number;
  success: number;
  rate: number | null;
};

export class CRotationSkipProvider {
  static async list(scope = 'payout'): Promise<CRotationSkip[]> {
    const res = await adminRequest.get<AdminResponse<CRotationSkip[]>>(
      UsdtUri(`/admin/c-rotation-skip?scope=${scope}`),
    );
    return res.data.data;
  }

  static async add(input: {
    scope: string;
    fromAddress: string;
    toAddress: string;
    remark?: string;
  }): Promise<CRotationSkip> {
    const res = await adminRequest.post<AdminResponse<CRotationSkip>>(
      UsdtUri('/admin/c-rotation-skip'),
      input,
    );
    return res.data.data;
  }

  static async remove(id: string): Promise<void> {
    await adminRequest.delete(UsdtUri(`/admin/c-rotation-skip/${id}`));
  }

  static async successRate(scope = 'payout', hours = 24): Promise<CRate[]> {
    const res = await adminRequest.get<AdminResponse<CRate[]>>(
      UsdtUri(`/admin/c-rotation-skip/success-rate?scope=${scope}&hours=${hours}`),
    );
    return res.data.data;
  }
}
